
import React from 'react';
import { CheckboxVisibility, DetailsList, DetailsListLayoutMode, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles, mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';

import { IfComp } from '../../../core';

import getAttributeValueAsText from '../getAttributeValueAsText';

const getAttributeData = (attribute) => {
    switch (attribute.type) {
        case 'float':
        case 'integer':
            return 'number';
        case  'date':
            return 'date';
        default:
            return 'string';
    }
}

const isAttributeAllow = (attribute, allowAttributes) => {
    let allow = (attribute.hidden !== true);
    if (allowAttributes) {
        allow = allow && (allowAttributes.indexOf(attribute.name) !== -1);
    }
    return allow
}

function getColumns(dataModelItem) {
    let allowAttributes = get(dataModelItem, 'operations.get.allowAttributes');

    let columns = dataModelItem.attributes.reduce((previous, current) => {
        if (isAttributeAllow(current, allowAttributes)) {
            previous.push({
                fieldName: current.name,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                key: current.name,
                minWidth: 30,
                maxWidth: 80,
                name: current.title,
                data: getAttributeData(current),

                onGetValue: (object) => {
                    return getAttributeValueAsText(current, object.attributes[current.name]);
                }
            });
        }
        return previous;
    }, []);

    columns.push({
        key: 'tools',
        minWidth: 20,
        maxWidth: 20,
        tools: [
            {key: 'detail', icon: 'Info', title: 'Zobrazit detail objektu'},
        ]
    });

    return columns;
}

const ObjectList = ({
    dataModelItem,
    objectList,
    onObjectClick,
    onSelectionChanged
}) => {

    const classNames = mergeStyleSets({
        ObjectList: {
        },
        content: {
            overflow: 'auto',
            height: 0
        },
        toolIcon: {
            fontSize: '16px',
            height: '16px',
            width: '16px',
            cursor: 'pointer'
        },
    });

    const [columns, setColumns] = React.useState([]);
    const [objects, setObjects] = React.useState([]);
    const [selection, setSelection] = React.useState();
    const [selectedObjectList, setSelectedObjectList] = React.useState([]);

    React.useEffect(() => {
        const _selection = new Selection({
            onSelectionChanged: () => {
                setSelectedObjectList(_selection.getSelection());
            }
        });
        setSelection(_selection);
    }, []);

    React.useEffect(() => {
        setColumns(getColumns(dataModelItem));
        setObjects(objectList || []);
    }, [dataModelItem, objectList]);

    React.useEffect(() => {
        doSelectionChanged();
    }, [dataModelItem, objects, selectedObjectList]);

    const copyAndSort = (items, column) => {
        const key = column.key;
        return items.slice(0).sort((a, b) => {
            return (column.isSortedDescending ? a.attributes[key] < b.attributes[key] : a.attributes[key] > b.attributes[key]) ? 1 : -1;
        });
    }

    const doSelectionChanged = () => {
        if (onSelectionChanged) {
            onSelectionChanged(getSelection());
        }
    }

    const getSelection = () => {
        return {
            objectCount: objects.length,
            selectedCount: selectedObjectList.length,
            workObjectList: (selectedObjectList.length > 0)
                ? selectedObjectList
                : objects
        };
    }

    const handleColumnHeaderClick = (ev, column) => {
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newObjects = copyAndSort(objects, currColumn);
        setColumns(newColumns);
        setObjects(newObjects);
    }

    const handleRenderItemColumn = (item, index, column) => {
        switch (column.key) {
            case 'tools':
                return renderToolsItemColumn(item, index, column);
            default:
                return renderNormalItemColumn(item, index, column);
            }
    }

    const handleToolClick = (tool, object) => {
        switch (tool) {
            case 'detail':
                if (onObjectClick) {
                    onObjectClick(object);
                }
                break;
        }
    }

    const renderNormalItemColumn = (item, index, column) => {
        const fieldContent = (column.onGetValue)
            ? column.onGetValue(item)
            : item[column.fieldName];

        let styles = {}

        return (
            <span
                className={mergeStyles(styles)}>
            {fieldContent}
            </span>
        );
    }

    const renderToolsItemColumn = (item, index, column) => {
        const fieldContent = column.tools.map(tool => {
            return (
                <Icon
                    key={tool.key}
                    iconName={tool.icon}
                    className={classNames.toolIcon}
                    title={tool.title}
                    onClick={() => {
                        handleToolClick(tool.key, item);
                    }}
                />
            );
        });
        return (
            <span data-selection-disabled={true}>
            {fieldContent}
            </span>
        );
    }

    return (
        <IfComp cond={selection}>
            <Stack verticalFill className={classNames.ObjectList} >
                <Stack.Item grow={1} className={classNames.content} data-is-scrollable="true">
                    <DetailsList
                        checkboxVisibility={CheckboxVisibility.always}
                        compact={true}
                        columns={columns}
                        isHeaderVisible={true}
                        items={objects}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onColumnHeaderClick={handleColumnHeaderClick}
                        onRenderItemColumn={handleRenderItemColumn}
                        selection={selection}
                        selectionMode={SelectionMode.multiple}
                        selectionPreservedOnEmptyClick={true}
                    />
                </Stack.Item>
            </Stack>
        </IfComp>
    );
}

export default ObjectList;
